/**
 * Media query breakpoints
 *
 * Check with #design before you add anything.
 * Keep in sync with src/styles/settings/_breakpoints.scss
 */
export enum FreelancerBreakpoints {
  MOBILE = '(min-width: 480px)',
  TABLET = '(min-width: 768px)',
  DESKTOP_SMALL = '(min-width: 960px)',
  DESKTOP_LARGE = '(min-width: 1200px)',
  DESKTOP_XLARGE = '(min-width: 1440px)',
  DESKTOP_XXLARGE = '(min-width: 1600px)',
  DESKTOP_XXXLARGE = '(min-width: 2560px)',
}

export const enum FreelancerBreakpointValues {
  MOBILE = '480px',
  TABLET = '768px',
  DESKTOP_SMALL = '960px',
  DESKTOP_LARGE = '1200px',
  DESKTOP_XLARGE = '1440px',
  DESKTOP_XXLARGE = '1600px',
  DESKTOP_XXXLARGE = '2560px',
}
